import * as yup from 'yup';

export const thirdPartyContactsFormValidation = () =>
  yup.object({
    firstName: yup.string().nullable().required(),
    middleName: yup.string().nullable(),
    lastName: yup.string().nullable().required(),
    emailAddress: yup.string().email().nullable().required(),
    phoneNumber: yup.string().nullable(),
    functions: yup.array().min(1).nullable().required(),
    notes: yup.string().nullable(),
  });
